import { useCallback, useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
import { useMediaBreakpoints } from './useMediaBreakpoints';
import { sizes } from '../breakpoints';
export const useMaxItemsSize = items => {
  const screen = useMediaBreakpoints(sizes);
  const [maxSize, setMaxSize] = useState(0);
  useDidUpdateEffect(() => {
    setMaxSize(0);
  }, [screen]);
  useDidUpdateEffect(() => {
    setMaxSize(0);
  }, [items]);
  const measureSize = useCallback(size => {
    if (size && size > maxSize) {
      setMaxSize(size);
    }
  }, [maxSize]);
  return [maxSize, measureSize];
};